var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"back-nav-btn",attrs:{"text":""},on:{"click":_vm.action}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._t("default",[_vm._v("Back")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }